import { Resiliation } from "modules/resiliation/model/resiliation";
import { TypeStep } from "modules/resiliation/store/resiliation.slice";
import React from "react";
import { FormulaireStep1 } from "./formulaire-step1";
import { FormulaireStep2 } from "./formulaire-step2";
import { FormulaireStep3 } from "./formulaire_step3";
import { FormulaireSubStep3 } from "./formulaire_subStep3";
import { FormulaireRecap } from "./formulaire-recap";

export interface IFormulaireProps {
    step: TypeStep;
    inProgress?: boolean;
    resiliation: Resiliation;
    recaptcha: string;
    compagnies:string[];
    submit: (resiliation: Resiliation) => void;
    cancel: () => void;
    goToStep: (step: any) => void;
}

export const FormulaireStep: React.FC<IFormulaireProps> = ({
    step,
    inProgress,
    resiliation,
    submit,
    goToStep,
    cancel,
    recaptcha,
    compagnies,
}) => {

    return (
        <div className="formulaire">
            {step === TypeStep.IdentificationContrat ? (
                <FormulaireStep2
                    resiliation={resiliation}
                    cancel={cancel}
                    submit={submit}
                    compagnies={compagnies}
                />
            ) : step === TypeStep.ChoixResiliation ? (
                <FormulaireStep3
                    resiliation={resiliation}
                    motif="Le motif de votre demande sera vérifié selon ce que votre contrat d'assurance et la législation permettent (durée d'engagement ferme ou non, préavis, etc...)."
                    cancel={cancel}
                    submit={submit}
                />
            ) : step === TypeStep.MotifResiliation ? (
                <FormulaireSubStep3
                    resiliation={resiliation}
                    cancel={cancel}
                    submit={submit}
                />
            ) : step === TypeStep.recap ? (
                <FormulaireRecap
                    resiliation={resiliation}
                    cancel={cancel}
                    submit={submit}
                    goToStep={goToStep}
                    recaptcha={recaptcha}
                    inProgress={inProgress}
                />
            ) : (
                //default
                <FormulaireStep1
                    resiliation={resiliation}
                    cancel={cancel}
                    submit={submit}
                />
            )}
        </div>
    );
};
